/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import MainNavigation from "@/components/layout/main-navigation";
import { Footer } from "@/components/landing/footer";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import {
  TermlyEmbed,
  TermlyPlaceholder,
} from "@/components/legal/termly-embed";

const TERMLY_COOKIE_POLICY_ID = "3f18a856-3d02-4039-b39f-96c86f4310d8";

export function CookiesPageClient() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <MainNavigation />

      <main className="flex-1">
        <div className="mx-auto max-w-4xl px-4 py-16 md:px-8 lg:py-24">
          <nav className="mb-6 text-xs text-muted-foreground">
            <Link href="/">Home</Link> / <Link href="/legal">Legal</Link> /{" "}
            <span className="text-foreground">Cookie Policy</span>
          </nav>
          <header className="mb-8 text-center">
            <h1 className="mb-4 text-2xl font-bold tracking-tight text-foreground md:text-3xl">
              Cookie Policy
            </h1>
            <p className="text-lg text-muted-foreground">
              Last updated:{" "}
              {TERMLY_COOKIE_POLICY_ID
                ? "Syncs automatically when Termly updates"
                : "February 2026"}
            </p>
            <div className="mt-4 flex justify-center gap-3">
              <Button asChild variant="outline" size="sm">
                <Link href="/legal">Back to Legal</Link>
              </Button>
              <Button
                size="sm"
                onClick={() => {
                  if (typeof window !== "undefined") {
                    window.print();
                  }
                }}
              >
                Download PDF
              </Button>
            </div>
          </header>

          <div className="prose prose-neutral dark:prose-invert max-w-none">
            {TERMLY_COOKIE_POLICY_ID ? (
              <TermlyEmbed dataId={TERMLY_COOKIE_POLICY_ID} />
            ) : (
              <div className="space-y-3">
                <TermlyPlaceholder policyType="Cookie Policy" />
                <p className="text-sm text-muted-foreground">
                  Administrators: set
                  <code className="mx-1 rounded bg-muted px-1 text-xs">
                    NEXT_PUBLIC_TERMLY_COOKIE_POLICY_ID
                  </code>
                  to replace this placeholder with your live Termly policy.
                </p>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
